import { DatePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { ExpireDateSecondVariant } from '@shared/models';
import { SafePipe, VariableReplacementPipe } from '@shared/pipes';

@Component({
  selector: 'b2c-variant2',
  styleUrl: './variant2.component.scss',
  templateUrl: './variant2.component.html',
  imports: [DatePipe, SafePipe, VariableReplacementPipe],
})
export class Variant2Component extends BaseComponent {
  campaignEndDate = input.required<string>();
  campaignStartDate = input.required<string>();
  config = input.required<ExpireDateSecondVariant>();
}
